import isArray from 'lodash/isArray';

export const state = () => {
  return {
    hideTrialCTA: false,
    isLoading: true,
    plans: [],
  };
};

export const actions = {
  async getPlans({ commit }) {
    try {
      commit('SET_IS_LOADING', true);
      const response = await this.$axios.get('/api/subscription-plans');
      commit('SET_PLANS', response?.data?.data || []);
      commit('SET_IS_LOADING', false);
    } catch {}
  },
  hideTrialCTA({ commit }) {
    commit('SET_HIDE_TRIAL_CTA', true);
  },
};

export const mutations = {
  SET_PLANS(state, payload) {
    if (isArray(payload) && payload.length) {
      state.plans = payload.map((item) => {
        return {
          id: item.plan_id,
          isDiscountable: item.is_discountable,
          summary: item.summary,
          title: item.title,
        };
      });
    } else {
      state.plans = [];
    }
  },
  SET_IS_LOADING(state, value) {
    state.isLoading = value;
  },
  SET_HIDE_TRIAL_CTA(state, value) {
    state.hideTrialCTA = value;
  },
};
